import { NativeStackNavigationOptions } from '@react-navigation/native-stack';

import { baseColor, commonText, textColor } from '@/styles/common';
import { StackNavigationOptions } from '@react-navigation/stack';

export const DefaultNavigationOptions: NativeStackNavigationOptions = {
  headerStyle: {
    backgroundColor: baseColor,
  },
  headerTitleAlign: 'center',
  headerTitleStyle: {
    ...commonText.title,
    color: textColor,
  },
  headerBackTitle: '戻る',
  headerTintColor: textColor,
};

export const DefaultLayoutOptions: StackNavigationOptions = {
  cardStyle: {
    width: '100%',
    maxWidth: 1024,
    marginHorizontal: 'auto',
    backgroundColor: '#fff',
    flex: 1,
  },
};
